import React, { useEffect, useState } from 'react'
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Button, TextField, withStyles, makeStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import StackedColumnChart from '../Graphs/StackedColumn';
import DataTable from '../Table';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Select from 'react-select';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { useDispatch, useSelector } from 'react-redux';
import { getAssetwithVendorCode, getVendorData } from '../../ReduxStore/VendorDataSlice';
import CustomBreadcrumbs from '../Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getBD_Reports, getUserReadable } from '../../ReduxStore/Breakdown/BreakdownSlice';
import ReportGraph from '../Graphs/ReportGraph';
import { convertUTCtoIST } from '../../helpers/DateConvert';

// Define custom styles
const useStyles = makeStyles({
    accordionDetails: {
        width: '100%',
        overflowX: 'auto', // Enable horizontal scrolling if content overflows
    },
    dataTable: {
        width: '100%',
        minWidth: '600px', // Ensure minimum width for better readability on larger screens
    },
});

// Create a styled version of the Button component
const CustomButton = withStyles({
    root: {
        fontSize: '14px',
        textTransform: 'Capitalize',
    },
})(Button);

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    control: (provided) => ({
        ...provided,
        minHeight: '54px',
        height: '54px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: '54px',
        padding: '0 8px',
    }),
};

const columns = [
    { id: 'Sr.no', label: 'Sr.no', minWidth: 50 },
    { id: 'machine_details.asset_no', label: 'Asset', minWidth: 80 },
    { id: 'reported_time', label: 'Reported time', minWidth: 50 },
    { id: 'time_to_attend', label: 'Time to attend', minWidth: 50 },
    { id: 'time_to_repair', label: 'Time to repair', minWidth: 50 },
    { id: 'time_to_resolve', label: 'Time to resolve', minWidth: 50 },
    { id: 'time_to_approve', label: 'Time to approve', minWidth: 50 },
    { id: 'time_to_notes', label: 'Time to notes', minWidth: 50 },
    { id: 'time_to_close', label: 'Time to close', minWidth: 50 },
    { id: 'time_between_failure', label: 'Time between failure', minWidth: 50 },
];


const BDReports = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' }
    ];

    const Role = localStorage.getItem("userRole");
    const [show, setShow] = React.useState(false);
    const [frequency, setfrequency] = useState();
    const [record, setRecord] = useState();
    const [formData, setFormData] = useState({
        startDate: '',
        endDate: '',
        // frequency: '',
    });
    const { response } = useSelector(state => state.vendor);
    const [SupplierOptions, setSupplierOptions] = useState(null);
    const [selectedSupplier, setselectedSupplier] = useState(null);
    const [vendorId, setVendorId] = useState(null);
    const [loading2, setLoading] = useState(false);
    const [masterData, setMasterData] = useState([]);
    const [chartData, setChartData] = useState();
    const [chartData2, setChartData2] = useState();
    const [AssetOptions, setAssetOptions] = useState([]);

    const frequencyOptions = [
        { value: 'day', label: 'Day' },
        { value: 'week', label: 'Week' },
        { value: 'month', label: 'Month' },
        { value: 'quarter', label: 'Quarter' },
        { value: 'yearly', label: 'Year' }
    ];

    // const formatDateTime = (date) => {
    //     return new Date(date).toISOString().slice(0, 19);
    // };
    const formatDateTime = (date) => {
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const dd = String(d.getDate()).padStart(2, '0');
        const hh = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        const ss = String(d.getSeconds()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };



    const handler = async () => {
        // console.log("data:", formData.startDate, formData.frequency, formData.endDate)
        try {
            const action = dispatch(getBD_Reports({ asset_id: vendorId, freq: frequency.value, fromTime: formatDateTime(formData.startDate), toTime: formatDateTime(formData.endDate) }));
            const res = await action.unwrap();
            if (res.result) {
                const reportKey = Object.keys(res.result.reports)[0]; // Get the first key dynamically
                console.log("check key===", reportKey)
                const reportData = res.result.reports[reportKey];
                console.log("check reportData", reportData)

                const chartData = {
                    title: "Breakdown Complaince",
                    subtitle: "Triggered vs Resolved vs Rejected",
                    categories: reportData.map((item) => item.time.split(" ")[0]), // Extract only the date part
                    yAxis: "Breakdowns",
                    series: [
                        {
                            name: "Triggered",
                            data: reportData.map((item) => item.breakdowns),
                            color: "#007bff", // Blue for Triggered
                        },
                        {
                            name: "Resolved",
                            data: reportData.map((item) => item.resolved),
                            color: "#28a745", // Green for Resolved 
                        },
                        {
                            name: "Rejected",
                            data: reportData.map((item) => item.rejected),
                            color: "#dc3545", // Reddish color for Rejected
                        },
                    ],
                };
                // ChartData2 for NG Submitted and Resolved
                const chartData2 = {
                    title: "NG Submitted vs Resolved",
                    categories: reportData.map((item) => item.time.split(" ")[0]), // Extract only the date part
                    yAxis: "Number of NG Tasks",
                    series: [
                        {
                            name: "NG Submitted",
                            data: reportData.map((item) => item.ng_submitted),
                        },
                        {
                            name: "NG Resolved",
                            data: reportData.map((item) => item.ng_resolved),
                        },
                    ],
                };

                setChartData(chartData);
                setChartData2(chartData2); // Update state for second chart
                console.log("hhhhhhhhhhhh", chartData)
                setShow(true)
            }
            const recordsArray = Object.keys(res.result.records).map(key => ({
                id: key,
                ...res.result.records[key]
            }));

            // Process the data to remove the first 3 letters from asset_no if it exists
            const modifiedData = recordsArray.map(item => ({
                ...item,
                machine_details: {
                    ...item.machine_details,
                    asset_no: item.machine_details?.asset_no ? item.machine_details.asset_no.slice(3) : item.machine_details.asset_no
                }
            }));

            const mergedLogs = modifiedData.map(log => {
                return {
                    ...log,
                    reported_time: convertUTCtoIST(log.reported_time)
                }

            });

            setRecord(mergedLogs);
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    };




    const assetDataforVendor = async () => {
        try {
            setLoading(true)
            const action = dispatch(getAssetwithVendorCode());
            const res = await action.unwrap();
            if (res.result) {
                setLoading(false)
                setMasterData(res.result)
            };
        } catch (error) {
            toast.error(error.message || "Asset Not Found!");
        } finally {
            setLoading(false)
        }
    }


    const UserReadeable = async () => {
        try {
            const action = dispatch(getUserReadable());
            const res = await action.unwrap();
            // console.log("res---------------", res.result.user.departments[0].assets[0].id)
            if (res.result) {
                setVendorId(res.result.user.departments[0].assets[0].id)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }

    useEffect(() => {
        if (Role === "admin" || Role === "view_only") {
            if (selectedSupplier) {
                setVendorId(selectedSupplier.value);
            }

        }
    }, [Role, selectedSupplier])


    useEffect(() => {
        if (Role === "admin" || Role === "view_only") {
            dispatch(getVendorData());
        } else {
            // dispatch(getAssetwithVendorCode());
            assetDataforVendor();
            UserReadeable();
        }
    }, [Role, dispatch])

    useEffect(() => {
        const Supplierlist = response && response.map(item => ({
            label: `${item.vendor_group} (${item.vendor})`,
            value: item.id
        }));

        if (Supplierlist) {
            setSupplierOptions(Supplierlist.map((item, index) => ({
                value: item.value,
                label: item.label
            })));
        }

        const Assetlist = masterData && masterData.map(item => ({
            value: item.Asset_id || item.id,
            // label: item.Asset_description || item['Asset description'],
            // label: `${item.Asset || item.Asset_no} - ${item['Asset description'] || item.Asset_description}`,
            label: `${(item.asset_no)?.slice(3) || (item.Asset_no).slice(3)} - ${item['Asset description'] || item.Asset_description}`,
        }));

        if (Assetlist) {
            setAssetOptions(Assetlist.map(item => ({
                value: item.value,
                label: item.label,
            })));
        }
    }, [masterData, response]);


    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Breakdown Reports" />
                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        {(Role === "admin" || Role === "view_only") && <Grid item xs={12} sm={2}>
                            <Select
                                styles={customStyles}
                                options={SupplierOptions}
                                placeholder="Select Vendor"
                                isSearchable
                                onChange={setselectedSupplier}
                                isClearable
                                menuPlacement="auto"
                            />
                        </Grid>}
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="From"
                                name="startDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.startDate}
                                onChange={handleInputChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="To"
                                name="endDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.endDate}
                                onChange={handleInputChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Select
                                styles={customStyles}
                                options={frequencyOptions}
                                placeholder="Select time frame"
                                isSearchable
                                isClearable
                                onChange={setfrequency}
                                menuPlacement="auto"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                // className="customButton"
                                startIcon={<SearchIcon />}
                                onClick={handler}
                            >
                                Search
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                {show && <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={10}>
                            {/* <StackedColumnChart data={chartData} /> */}
                            <ReportGraph data={chartData} />
                        </Grid>
                        <Grid item xs={6}>
                            {/* <StackedColumnChart data={chartData2} /> */}
                        </Grid>
                        {/* <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography>View Table</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <DataTable data={record} columns={columns} />
                                    </AccordionDetails>
                                </Accordion>

                            </Grid>
                        </Grid> */}
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography>View Table</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className={classes.accordionDetails}>
                                        <div className={classes.dataTable}>
                                            <DataTable data={record} columns={columns} />
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>}
            </Container>
            <ToastContainer />
        </Layout>
    )
}

export default BDReports